import { Box, Grid, SvgIcon, Typography } from '@hermes/web-components'
import React, { useContext } from 'react'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { FacilityItem } from '../../../types'
import { AppDataContext } from '../../../providers/AppData'

const ServicesSection = ({ services }: { services: FacilityItem[] }) => {
  const translate = useTranslateMessage()
  const servicesItems = services[0]?.items || []
  const { language } = useContext(AppDataContext)

  return (
    <Grid container>
      <Grid item xs={12} md={12} lg={9}>
        <Typography variant="h2" component="h2" mb="4px" fontWeight="200" color="text.darkNavy">
          {translate('services')}
        </Typography>
        <Grid container>
          {servicesItems.map(({ name }, index) => (
            <Grid item xs={12} sm={6} lg={4} pt="12px" pr="20px" key={`service-${name[language]}-${index}`}>
              <Box display="flex" alignItems="flex-start" lineHeight="26px" gap="4px">
                <SvgIcon sx={{ width: '24px', height: '24px' }}>
                  <use href="#tick-icon" />
                </SvgIcon>
                {name[language]}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ServicesSection
